import React, { useState } from 'react';
import { FiSearch, FiArrowLeft, FiFolder, FiCheckCircle } from 'react-icons/fi';
import { useTask } from '../contexts/TaskContext';

const InReviewTab = ({ onBack, onOpenTask }) => {
    const { tasks } = useTask();
    const [search, setSearch] = useState('');

    const reviewTasks = tasks.filter(t => t.status === 'review');

    const filteredTasks = reviewTasks.filter(t =>
        (t.title || '').toLowerCase().includes(search.toLowerCase()) ||
        (t.createdBy?.username || '').toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="admin-tab-content standalone-trash">
            <div className="tab-header">
                <div className="header-left">
                    {onBack && (
                        <button className="back-btn-link" onClick={onBack} title="Go Back">
                            <FiArrowLeft size={20} />
                        </button>
                    )}
                    <h2><FiCheckCircle size={20} /> In Review</h2>
                    <span className="count-badge">{filteredTasks.length} tasks</span>
                </div>
                <div className="header-actions">
                    <div className="search-box">
                        <FiSearch size={16} />
                        <input
                            placeholder="Search review tasks..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="trash-list-container">
                {filteredTasks.length > 0 ? (
                    <div className="trash-grid">
                        {filteredTasks.map(task => (
                            <div key={task._id} className="trash-item" onClick={() => onOpenTask && onOpenTask(task)}>
                                <div className="trash-item-info">
                                    <div className="trash-item-header">
                                        <h3 className="mb-2 text-lg font-semibold">{task.title}</h3>
                                        <span className="trash-item-date">{new Date(task.updatedAt).toLocaleDateString()}</span>
                                    </div>
                                    <p className="trash-item-desc">{task.description?.substring(0, 100)}{task.description?.length > 100 ? '...' : ''}</p>
                                    <div className="trash-item-meta">
                                        <span className="meta-label">Created by: {task.createdBy?.username || 'Unknown'}</span>
                                        {task.projectId && (
                                            <span className="meta-project" style={{ color: task.projectId?.color || '#000' }}>
                                                <FiFolder size={12} /> {task.projectId?.name || 'Project'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <FiCheckCircle size={48} />
                        <p>No tasks in review</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InReviewTab;
